import { Button, FormHelperText, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";

export function CustomFilePicker({
  error,
  selectedFiles,
  setSelectedFiles,
  pickerId,
  multiple,
  fileType,
}) {
  const [fileInputKey, setFileInputKey] = useState(0);

  const handleFileSelect = (event) => {
    let files = [];
    [...event.target.files].forEach((file) => {
      files.push({ file: file, name: file.name });
    });
    setSelectedFiles(multiple ? [...selectedFiles, ...files] : [...files]);
    setFileInputKey(fileInputKey + 1);
  };

  const handleFileRemove = (index) => {
    const updatedImages = [...selectedFiles];
    updatedImages.splice(index, 1);
    setSelectedFiles(updatedImages);
  };

  return (
    <div>
      <label htmlFor={`upload-${pickerId}-photo`}>
        <br />
        <input
          style={{ display: "none" }}
          id={`upload-${pickerId}-photo`}
          name={`upload-${pickerId}-photo`}
          type="file"
          accept={fileType}
          multiple={multiple}
          onChange={handleFileSelect}
        />
        <Fab
          sx={{ p: "20px", mb: 1, fontSize: "12px" }}
          color="primary"
          size="small"
          component="span"
          aria-label="add"
          variant="extended"
        >
          <AddIcon sx={{ mb: "3px", fontSize: "14px" }} /> Add {pickerId}
          {multiple ? " file(s)" : "file"}
        </Fab>
        <FormHelperText sx={{ fontSize: "15px" }} error={error && true}>
          {error !== "" ? error : ""}
        </FormHelperText>
        <FormHelperText sx={{ fontSize: "15px" }}>
          {selectedFiles.length > 0
            ? `${selectedFiles.length} file(s) selected`
            : `Select ${pickerId} file(s) to upload`}
        </FormHelperText>
      </label>

      {selectedFiles.map((fileObject, index) => (
        <Grid container key={index}>
          <Grid item xs={12} mt={4} ml={1}>
            <Typography variant="paragraph">{fileObject.name}</Typography>
          </Grid>
          <Button
            sx={{
              mb: 3,
            }}
            color="error"
            onClick={() => handleFileRemove(index)}
          >
            Remove
          </Button>
        </Grid>
      ))}
    </div>
  );
}
